import { ISubwallets } from '../mcc/types/Wallets';

export const getCurrenciesForWallet = (subwallets: ISubwallets[] | null) => {
  if (!subwallets) return [];
  return subwallets.map((wallet) => wallet.currency);
};
